module.exports = __webpack_public_path__ + "static/media/bolinhoaipimmoidamini.93b46bb8.webp";